/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  IAppState,
  RouteHelper,
  useConfigurationSelector,
  useIsLoggedIn,
  UserStore,
} from "@xala/common";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LoaderSpinner, RegisterForm } from "components";
import { AuthScreen } from "screens/AuthScreen";

import "./EditFavoriteContentsComponent.scss";

export const EditFavoriteContentsComponent = () => {
  const dispatch = useDispatch();
  const configuration = useConfigurationSelector();
  const isLoggedIn = useIsLoggedIn();

  const { IsProcessing: IsLoadingProfile } = useSelector(
    (state: IAppState) => state.user.settings
  );

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(UserStore.Actions.getUserConsents());
      dispatch(UserStore.Actions.getUserSettings());
    } else {
      RouteHelper.goToLogin();
    }
  }, [dispatch, isLoggedIn]);

  return (
    <AuthScreen configuration={configuration} visibility={7}>
      <div className="EditFavoriteContentsContainer">
        {IsLoadingProfile ? <LoaderSpinner /> : <RegisterForm isEditScreen />}
      </div>
    </AuthScreen>
  );
};
